import { Box, Button, ButtonGroup, Select, Stack, styled } from '@mui/material';

export const PreviewWrapper = styled(Box)`
  display: flex;
  flex-direction: column;
`;

export const PreviewHeader = styled(Box)`
  margin-bottom: 40px;
`;

export const PreviewFilters = styled(Box)`
  height: 42px;
  margin-bottom: 20px;
  display: flex;
  justify-content: space-between;
`;

export const PreviewContentWrapper = styled(Box)(
  ({ theme }) => `
  flex: 1;
  border-top: 1px solid ${theme.palette.divider};
  `,
);

export const PreviewContentBox = styled(Box)`
  height: 85vh;
  width: 100vw;
  padding-bottom: 20px;
  padding-top: 20px;
  display: flex;
  flex-direction: column;
  min-height: 0;
`;
export const PreviewHeaderContainer = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;
export const RoundedDropdown = styled(Select)(
  ({ theme }) => `
    color:${theme.palette.brand.muted};
    border-radius: 56px;
    width: 220px;
    height: 40px;
    @media (max-width: 1300px) {
      width: auto;
    }
  `,
);
export const StyledStack = styled(Stack)`
  gap: 16px;
  align-items: center;
`;

export const ButtonGroupWrapper = styled(ButtonGroup)(
  ({ theme }) =>
    `
    width: fit-content;
    margin: 40px auto 32px;
    display: flex;
    justify-content: center;
    border: 1px solid ${theme.palette.primary.main};
    overflow: hidden;
  `,
);

export const StyledToggleButton = styled(Button)<{ $active?: boolean }>(
  ({ $active, theme }) => ({
    backgroundColor: $active
      ? theme.palette.primary.main
      : theme.palette.primary.lightest,
    color: $active
      ? theme.palette.primary.lightest
      : theme.palette.primary.main,
    borderRadius: '4px',
    '&:hover': {
      backgroundColor: $active
        ? theme.palette.primary.main
        : theme.palette.primary.lightest,
    },
  }),
);

export const GCFPreviewBox = styled(Box)`
  flex: 1;
  min-height: 0;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const PreviewLayer = styled(Box, {
  shouldForwardProp: (prop: string) => prop !== '$visible',
})<{ $visible: boolean }>(({ $visible }) => ({
  position: 'absolute',
  inset: 0,
  visibility: $visible ? 'visible' : 'hidden',
  pointerEvents: $visible ? 'auto' : 'none',
}));
